// extracted by mini-css-extract-plugin
module.exports = {"side-bar-wrapper":"_2wUg_","ad-wrapper":"_1v3nU"};